import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  CircularProgress,
  Grid,
  Paper,
  styled,
  Typography,
  useTheme,
} from '@mui/material';
import Flecha from '../assets/icons/flecha-icon';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { store } from '../store.js';
import {
  getQuestions,
  Preguntas,
} from '../features/preguntas/preguntasSlice.js';
import AccordionIcon from '../assets/icons/accordion-icon';

const AccordionWrapper = styled(Paper)(({ theme }) => ({
  border: '1px solid',
  borderColor: theme.palette.grey[300],
  display: 'flex',
  flexDirection: 'column',
  padding: '1.5rem 2rem 1.5rem 2rem',
}));

const LinkItem = styled(Link)<{ component: 'Link' }>(({ theme }) => ({
  textDecoration: 'none',
  borderBottom: '1px solid',
  borderColor: theme.palette.grey[400],
  display: 'flex',
  alignItems: 'center',
}));

const QuestionTitle = styled(Typography)(({ theme }) => ({
  fontSize: '.875rem',
  fontWeight: 600,
  letterSpacing: 0,
  color: theme.palette.grey[600],
}));

const PreguntasFrecuentesSection = () => {
  const theme = useTheme();

  const [preguntas, setPreguntas] = useState<Preguntas[]>([]);

  useEffect(() => {
    store
      .dispatch(getQuestions(''))
      .unwrap()
      .then((response) => {
        setPreguntas(response);
      });
  }, []);

  return (
    <Grid item lg={4}>
      <AccordionWrapper>
        <Box
          mb="1rem"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              width: '70%',
            }}
          >
            <Typography variant="subtitle1" mr={2}>
              Preguntas Frecuentes
            </Typography>
            {preguntas.length <= 1 ? <CircularProgress size={20} /> : null}
          </Box>

          <LinkItem component="Link" to="/preguntas-frecuentes">
            <Typography
              sx={{
                marginRight: '.3rem',
                fontSize: '.75rem',
                letterSpacing: 0,
                fontWeight: 'bold',
                color: theme.palette.grey[400],
              }}
            >
              {' '}
              VER TODAS
            </Typography>
            <Flecha color={theme.palette.grey[400]} />
          </LinkItem>
        </Box>

        {preguntas.map((pregunta) => (
          <Accordion key={`pregunta_${pregunta.id}`}>
            <AccordionSummary expandIcon={<AccordionIcon />}>
              <QuestionTitle>{pregunta.pregunta}</QuestionTitle>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>{pregunta.respuesta}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </AccordionWrapper>
    </Grid>
  );
};

export default PreguntasFrecuentesSection;
